<template>
  <div class="c-sitter__feedback">
    <div class="divider"></div>
    <fieldset id="private_feedback" class="c-feedback__form" name="private_feedback">
      <p class="c-feedback__title">Share feedback with Sittercity</p>
      <p class="c-feedback__subheader c-feedback__subheader--private">
        We use your feedback to assess and remedy any issues. This feedback is only seen by Sittercity and is never shared with
        {{ sitterFirstName }}.
      </p>
      <PoppinsTextArea
        id="private_feedback_text"
        v-model="privateFeedback"
        name="private_feedback_text"
        class="mb-32 review-feedback-box"
        :rows="6"
        label-name="Your private feedback..."
        @keyup-once="ratingSegmentEvent('Rating Feedback Started')"
        @update:model-value="onInput"
      />
      <PoppinsButton
        id="createPrivateReview"
        type="submit"
        variant="primary"
        size="medium"
        :disabled="isPrivateFeedbackEmpty || null"
        :value="`Rate ${sitterFirstName}`"
        class="mr-8 w-full sm:!w-auto"
        @click.prevent="createPrivateReview"
      />
      <PoppinsButton
        value="Cancel Review"
        :href="cancelHref"
        variant="text"
        class="w-full sm:!w-auto mt-16 sm:mt-0"
        @click="handleCancel"
      />
    </fieldset>
  </div>
</template>

<script lang="ts">
import TextArea from '@/components/textarea/TextArea.vue';
import Button from '@/components/button/Button.vue';

export default {
  name: 'PrivateFeedback',
  components: {
    PoppinsTextArea: TextArea,
    PoppinsButton: Button,
  },
  props: {
    returnPath: {
      type: String,
      required: true,
    },
    ratingSegmentEvent: {
      type: Function,
      required: false,
      default: () => {},
    },
    sitterFirstName: {
      type: String,
      required: true,
    },
    createPrivateReview: {
      type: Function,
      required: true,
    },
    onCancel: {
      type: Function,
      required: false,
      default: null,
    },
  },
  data(): any {
    return {
      privateFeedback: '',
    };
  },
  computed: {
    cancelHref(): string {
      if (this.onCancel) {
        return '';
      }
      return this.returnPath;
    },
    isPrivateFeedbackEmpty(): boolean {
      return this.privateFeedback.length === 0;
    },
  },
  methods: {
    onInput() {
      this.$emit('update:modelValue', this.privateFeedback);
    },
    handleCancel(event) {
      this.ratingSegmentEvent('Rating Abandoned');
      if (this.onCancel) {
        event.preventDefault();
        this.onCancel();
      }
    },
  },
};
</script>
